<template>
    <NavBar />
    <router-view />
</template>
<style>
.in-beta{
  .navbar {
    background: rgb(159, 22, 45);
  }
}
</style>
<script setup lang="ts">
</script>